<nav aria-label="Op deze pagina">
	<h2>Snel naar</h2>
	<ol class="o-arrows-list">
		@for (visibleElement of visibleElements; track visibleElement.fragment) {
			<li>
				<a [routerLink]="['./']" fragment="{{visibleElement.fragment}}">{{visibleElement.title}}</a>
			</li>
		}
	</ol>
</nav>
